import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { fomateDate } from '../../utils/fomateDate';
import Operations from '../reusable/Operations';
import { useNavigate } from 'react-router-dom';
import { deleteAtributeThunk, deletemultipleAtributesThunk, setEditAtribute, setSelectallattributes, setSelectedatributesids } from '../../redux/atributes/getAllAtributes';
import { MultipleDeletes } from '../../Svg';
// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const VariantsTable = ({ atributes, start, end, setPage, page, totalItems, itemsPerPage, handleOpenMenu }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeColumn, setActiveColumn] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { selectedIds, selectAll } = useSelector((state) => state.atributes);


  const deleteCategory = () => {
    dispatch(deleteAtributeThunk(selectedId))
    setIsModalOpen(false);
  }


  const handleDeleteClick = (selectedId) => {
    setSelectedId(selectedId)
    setIsModalOpen(true);
  };

  const handleEditClick = (atribute) => {


    dispatch(setEditAtribute(atribute));
    navigate('/master/editVariants')
  };


   const handleSelect = (id) => {
      const isExist = selectedIds.includes(id)
      if (isExist) {
        const filter = selectedIds?.filter(i => i !== id)
        return dispatch(setSelectedatributesids(filter))
      }
      const data = [...selectedIds, id]
      dispatch(setSelectedatributesids(data))
    }
  
  
    const handleSelectAll = () => {
      if (!selectAll) {
        const ids = atributes?.map(i => i?._id)
        dispatch(setSelectedatributesids(ids))
        return dispatch(setSelectallattributes(true))
      }
      dispatch(setSelectedatributesids([]))
      dispatch(setSelectallattributes(false))
    }
  
    const handleMultipledelete = () => {
      const data = {
        ids: selectedIds
      }
      dispatch(deletemultipleAtributesThunk(data))
    }


    

  return (
    <>
      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>

              {/*   <HeaderCell padding="checkbox" sx={{ width: '2%' }}>
                <Checkbox color="primary" />
              </HeaderCell> */}

              <HeaderCell>
                <IconButton>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </IconButton>
                Attribute name
                <IconButton onClick={(e) => handleOpenMenu('variant_name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell >
                Values
                <IconButton onClick={(e) => handleOpenMenu('variation_value')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Added
                <IconButton onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
                {selectedIds?.length > 0 &&
                  <IconButton onClick={handleMultipledelete}>
                    <MultipleDeletes />
                  </IconButton>
                }
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {atributes.map((row) => (
              <TableRow key={row.id}>


                <TableCells sx={{
                  width: '23%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* <div>
                      {
                        row?.thumbnail?.photo ? <img src={row?.thumbnail?.photo} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div> */}
                    <div>
                      <input
                        type="checkbox"
                        checked={selectedIds.find(i => i == row?._id)}
                        onChange={() => handleSelect(row?._id)}
                      />
                    </div>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row.variant_name}</strong>
                      <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500', }}>
                        {/* {row.content} */}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '23%', color: "#667085", }}>{row?.variation_value?.join(' , ')}</ProductText>


                <TableCells sx={{ width: '13%' }}>
                  {row?.status === "ACTIVE" ? (
                    <ActiveChip label="Active" size="small" />
                  ) : (
                    <InactiveChip label="Inactive" size="small" />
                  )}
                </TableCells>

                <TableCells sx={{ width: '13%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/master/viewVariants/${row?._id}`)}
                  editClick={() => handleEditClick(row)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                />
                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Attributes'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default VariantsTable;
